const TOKEN_KEY = 'id_token';
const USER_KEY = 'user_key';
const ACCESS_TOKEN_KEY = 'access_token';

const defaultState = {
    user: localStorage.getItem(USER_KEY) ? JSON.parse(localStorage.getItem(USER_KEY)) : null,
    token: localStorage.getItem(TOKEN_KEY) || null,
    access_token: localStorage.getItem(ACCESS_TOKEN_KEY) || null,
};

const getters = {
    access_token: (state) => state.access_token,
    token: (state) => state.token,
    user: (state) => state.user
};

const actions = {
    async setUser(context, { user }) {
        try {
            localStorage.setItem(USER_KEY, JSON.stringify(user));
            context.commit('setUser', { user });
        } catch(error) {
            console.log(error)
        }
    },
    async setToken(context, { id_token, access_token }) {
        try {
            localStorage.setItem(TOKEN_KEY, id_token);
            context.commit('setToken', { id_token });
            localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
            context.commit('setAccessToken', { access_token });
        } catch(error) {
            console.log(error)
        }
    },
    async clear(context) {
        try {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
            localStorage.removeItem(ACCESS_TOKEN_KEY);
            context.commit('setAccessToken', { access_token: null });
            context.commit('setToken', { id_token: null });
            context.commit('setUser', { user: null });
        } catch(error) {
            console.log(error)
        }
    }
};
const mutations = {
    setAccessToken(state, { access_token }) {
        state.access_token = access_token;
    },
    setToken(state, { id_token }) {
        state.token = id_token;
    },
    setUser(state, { user }) {
        state.user = user;
    }
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    actions,
    mutations,
};
